<template>
  <div class="warning-wrapper">
    <FTItem
      class="wrapper"
      v-for="(item, index) in getshowwf(warningfo)"
      :content="item"
      :key="index"
    ></FTItem>
    <FTItem
      class="wrapper"
      v-for="(item, index) in bpList"
      :content="item"
      :key="index"
    ></FTItem>
  </div>
</template>

<script>
import FTItem from '@/components/Fund-Tip-item.vue';
import StoreManger from '@/utils/FundHQJHManger';
import JS from '@/base/JSTool';
// import { mapGetters } from 'vuex';

export default {
  name: 'WarningMidBar',
  props: {},
  computed: {
    // ...mapGetters({
    //   baseInfo: 'currentConfigureBaseInfo',
    // }),
  },
  components: {
    FTItem,
  },
  data() {
    return {
      bpList: [],
      contentList: ['根据证监会规定，3月30日起，基金公司将对旗下部分产品持续持有期少于7个自然日的投资者收取不低于1.5%的赎回费，点此了解详情>>>', '策略选基抢占年前最后上车机会策略选基抢占年前最后上车机会'],
      closable: true,
      showIcon: true,
      show: true,
      warn_red_src: '@/assets/warn-tip-red.png',
      close_src: '@/assets/warn-tip-close.png',
      fundCode: '',
      warningfo: {},
    };
  },
  created() {
    this.fundCode = this.$store.state.native.fund.fundCode;
    this.handleDefault();
  },
  methods: {
    render() {
      this.fundCode = this.$store.state.native.fund.fundCode;
      this.getFundMNBonusPointsTip();
      this.warningfo = StoreManger.getFundJJTX();
    },
    handleDefault() {},
    clickAction() {

    },
    getFundMNBonusPointsTip() {
      const bpData = StoreManger.getFundFHTX();
      const baseInfo = StoreManger.getFundJJXQ();
      const code = StoreManger.getFundJJXQCODE(baseInfo);
      if (bpData && bpData.length > 0) {
        const fItem = bpData[0];
        const fh = fItem.BONUS ? fItem.BONUS : '';

        const fPTYPE = fItem.FPTYPE ? fItem.FPTYPE : '';
        let fhpz = `该基金近期有分红，每份分红${fh}元在除息日(${fItem.EXDDATE})从净值中先扣除，当日净值下降不影响实际收益。`;
        if (fPTYPE === 2) {
          fhpz = '该基金近期有折算，折算期间净值会先除权，导致净值下降/上升，但不影响实际收益。';
        }
        this.bpList = [
          {
            TipType: '1',
            TipIcon: '',
            Tip: '',
            TipColor: '',
            Title: fhpz,
            HotKey: '',
            SubTitle: '详情 ＞',
            SubHotKey: '详情 ＞',
            show: '1',
            Mode: '0',
            Link: {
              LinkType: 2,
              AdId: 0,
              LinkTo: `fund://mp.1234567.com.cn/weex/b34ccfc4ed9a4af4a4880fee485cf417/pages/FundDividendDistribution?FCODE=${code}`,
              IsVerifyLogin: false,
            },
          }];
      }
    },
    getshowModule(item) {
      let ishqb = '0';
      const fundData = StoreManger.getFundJJXQ();
      const BAGTYPE = JS.fetchString(fundData, 'BAGTYPE');
      if (BAGTYPE === '1') {
        ishqb = '1';
      }
      if (ishqb === '0') {
        return [];
      }
      if (item) {
        const { FundDetailConfig } = item;
        if (FundDetailConfig) {
          const { Modules } = FundDetailConfig;
          const ptList = this.getshowListModule(Modules, 'HuoQiBao');
          return ptList;
        }
      }
      return [];
    },
    getshowListModule(Modules, code) {
      if (Modules) {
        const showModules = Modules.filter(
          (item) => (item.ModuleCode === code && item.CustomArray.length > 0),
        );
        if (showModules.length > 0) {
          const showModule = showModules[0];
          let { CustomArray } = showModule;
          CustomArray = CustomArray.filter((item) => item.Link).map((item) => {
            const result = item;
            result.show = '1';
            return result;
          });
          return CustomArray;
        }
      }
      return [];
    },
    getshowwf(item) {
      const conlist = JS.fetchArray(item, 'WARNLIST');
      const list = [];
      conlist.forEach((obj) => {
        list.push({
          TipType: '1',
          TipIcon: '',
          Tip: '',
          TipColor: '',
          Title: obj.WARN,
          HotKey: '',
          SubTitle: '',
          SubHotKey: '',
          show: '1',
          Mode: '0',
          Link: obj.Link,
        });
      });
      return list;
    },
    closeWarning() {
      this.show = false;
      this.$emit('closeEvent');
    },
  },
};
</script>

<style scoped>
.warning-wrapper {
  padding-left: 24px;
  padding-right: 24px;
}
.wrapper {
  /* border-bottom: 2px solid #ffd41d; */
  /* padding: 10px 0 15px 15px; */
  display: flex;
  flex-direction: row;

  margin-bottom: 24px;
  background: #fff7bc;
  padding-left: 25px;
  border-radius: 12px;
}

.text-wrapper {
  line-height: 24px;
  flex: 1;
  align-items: center;
}

.content {
  font-family: PingFangSC-Regular;
  font-size: 24px;
  color: #ff0000;
}

.warn_red_img {
  width: 22px;
  height: 22px;
  margin-right: 10px;
}

.close_view {
  width: 50px;
  padding-right: 20px;
  text-align: right;
}

.close_img {
  width: 26px;
  height: 26px;
}
</style>
